export const iconFontAwesomeCodingWindowMaximize = (
	<i className="fa-solid fa-window-maximize"></i>
);
